module.exports = __webpack_public_path__ + "img/BETWINNER.7d4c37c3.svg";